export default __webpack_public_path__ + "static/educators-07f1237f650b5ffed97edfc3ea164593.png";